import { omit, isPlainObject } from "lodash";
import { encodedLS, miniId, isEmpty } from "vuelpers";
import vuexPersistedState from "vuex-persistedstate";

const omitProperty = (object, ...properties) => {
	const traverse = (object, path = '') => {
		return Object.entries(object).reduce((data, [key, value]) => {
			const currentPath = !path ? key : `${path}.${key}`;
			if (properties.includes(key) || properties.includes(currentPath)) {
				return data
			}
			else if (isPlainObject(value)) {
				data[key] = traverse(value, currentPath)
			}
			else data[key] = value
			return data;
		}, {});
	}
	return traverse(object)
};

export default ({ key = miniId(), paths }) => {
	return vuexPersistedState({
		key,
		paths,
		storage: {
			getItem: (key) => {
				console.log('getItem', encodedLS.getItem(key))
				return encodedLS.getItem(key)
			},
			removeItem: encodedLS.removeItem,
			setItem: (key, value) => {
				encodedLS.setItem(key,
					omitProperty(JSON.parse(value), 'ref', 'isSubscribed')
				)
			},
		}
	})
}